module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/4/3-816bba8915bc146331c57f14b476d546.jpg";